import create from 'zustand';

interface SearchQueryInputState {
  searchQueryInput: string;
  setSearchQueryInput: (queryInput: string) => void;
}

interface CategoryNameState {
  currentCategoryName: string;
  setCurrentCategoryName: (categoryName: string) => void;
}

interface CategoryIdState {
  currentCategoryId: string;
  setCurrentCategoryId: (categoryId: string) => void;
}

interface AlphabetSearchState {
  alphabetSearchCharacter: string;
  setAlphabetSearchCharacter: (char: string) => void;
  setSearchType: () => void;
}

interface SearchStates {
  isAlphabetSearch: boolean;
  isInputSearch: boolean;
  isCategorySearch: boolean;
}

interface InitialSetup {
  initialCategoryId: string;
  setInitialCategoryId: (categoryId: string) => void;
  initialSubCategoryId: string;
  setInitialSubCategoryId: (subCategoryId: string) => void;
}

interface SearchState
  extends CategoryNameState,
    CategoryIdState,
    AlphabetSearchState,
    SearchQueryInputState,
    SearchStates, InitialSetup {
}

export const useSearchStore = create<SearchState>()(
  ((set) => ({
      isAlphabetSearch: false,
      isInputSearch: false,
      initialCategoryId: '',
      initialSubCategoryId: '',
      isCategorySearch: false,
      currentCategoryName: '',
      setCurrentCategoryName: (categoryName) =>
        set((state) => ({
          currentCategoryName: categoryName,
          isAlphabetSearch: state.alphabetSearchCharacter.length > 0,
          isInputSearch: state.searchQueryInput.length > 1,
          isCategorySearch: state.currentCategoryName.length > 0
        })),
      currentCategoryId: '',
      setCurrentCategoryId: (categoryId) =>
        set((state) => ({
          currentCategoryId: categoryId
        })),
      searchQueryInput: '',
      setSearchQueryInput: (queryInput) =>
        set((state) => ({
          searchQueryInput: queryInput,
          isAlphabetSearch: state.alphabetSearchCharacter.length > 0,
          isInputSearch: queryInput.length > 1,
          isCategorySearch: state.currentCategoryName.length > 0
        })),
      alphabetSearchCharacter: '',
      setAlphabetSearchCharacter: (char) =>
        set((state) => ({
          alphabetSearchCharacter: char,
          isAlphabetSearch: char.length > 0,
          isInputSearch: state.searchQueryInput.length > 1,
          isCategorySearch: state.currentCategoryName.length > 0
        })),
      setSearchType: () =>
        set((state) => ({
          isAlphabetSearch: state.alphabetSearchCharacter.length > 0,
          isInputSearch: state.searchQueryInput.length > 1,
          isCategorySearch: state.currentCategoryName.length > 0
        })),
      setInitialCategoryId: (categoryId) =>
        set((state) => ({
          initialCategoryId: categoryId
        })),
      setInitialSubCategoryId: (subCategoryId) =>
        set((state) => ({
          initialSubCategoryId: subCategoryId
        }))
    })
  )
);
